import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=68d1bb27&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"
import style0 from "./Summary.vue?vue&type=style&index=0&id=68d1bb27&prod&lang=scss&scoped=true"
import style1 from "./Summary.vue?vue&type=style&index=1&id=68d1bb27&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d1bb27",
  null
  
)

export default component.exports